/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { Checkbox, FormControlLabel, Grid, TextField } from '@material-ui/core';
import moment from 'moment';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithBox';
import {
  FROM_QTR_CANNOT_BE_GREATER_THAN_TO_QTR,
  FROM_QTR_REQUIRED,
  MAX_NDC_ALLOWED,
  NDC_LIMIT_TO_1000,
  REBATE_SELECT,
  TO_QTR_REQUIRED,
} from '../../../../SharedModules/Errors/constantMessageData';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  getRebateProgrameList,
  getPlanTypeValues,
  setSearchInput,
  dispatchErrorMsgNDCDetail,
  getLabelerList,
  setNDCHistoryData,
  getndchistorygrid,
  ndcHistoryDetailDisp,
  dispatchSelectType
} from '../Store/actions';
import { viewClaimDetailButton } from './ConstantData';
import {
  autoFormateDate,
  compareQuarterAndYear,
  convertToFourDigitYear,
  tabHighLigther,
  validateQuarter,
} from '../../../../SharedModules/utilities/utilities';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import SearchTypeComponent from '../../../../SharedModules/SearchTypeComponent/SearchTypeComponent';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';

export default function ReqNDCHistory(props) {
  const dispatch = useDispatch();

  const {
    planType: planTypeList,
    rebateProgramList: rebateProgramListData,
    rebateProgram: rebateProgramValue,
    plan,
    errors,
    errorMsgPerDisRes: getErrorMsg,
    selectedSearchType,
    isAllQuartersValue,
    fromQtrValue,
    toQtrValue,
    selectedNDC,
    ndcLeftTableData: ndcLeftTableDataArr,
    labelerSelectedRow: labelerSelectedRowValue,
    searchResult,
  } = useSelector((state) => state?.sharedState?.NDCHistoryReducer);

  const requestCurrentDisData = useSelector(
    (state) =>
      state?.sharedState?.NDCHistoryReducer?.performDisputeResolutionObj
  );

  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  // get error msg for NDC
  const getErrorsFromSearchTypeComponent = (errors) => {
    if (errors) {
      let alreadyPresentErrors = getErrorMsg?.searchScreenErrors
        ? getErrorMsg?.searchScreenErrors
        : [];
      setErrorMsgFromSearchType(errors);
      alreadyPresentErrors = alreadyPresentErrors.filter(
        (item) => item?.errorComponent !== 'searchTypeComponent'
      );
      alreadyPresentErrors = alreadyPresentErrors.concat(errors);
      dispatch(
        dispatchErrorMsgNDCDetail({
          searchScreenErrors: [...new Set(alreadyPresentErrors)],
        })
      );
    }
  };
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [errorList, setErrorList] = useState(errors);
  const [rebateProgram, setRebateProgram] = useState(rebateProgramValue);
  const [radioList, setRadioList] = useState([]);
  const [isAllQuarters, setIsAllQuarters] = useState(isAllQuartersValue);
  let intialState = selectedSearchType?selectedSearchType:userDefaults?.defNdcSelectModeCd?
  userDefaults?.defNdcSelectModeCd:"NDC";
  if (intialState === "NAME") {
    intialState = "Name";
  } else if (intialState === "LABELER") {
    intialState = "Labeler";
  } 
  const [searchType, setSearchType] = useState(intialState);
  const [planType, setPlanType] = useState(plan);
  const [selectList, setSelectList] = useState([]);
  const [fromQtr, setFromQtr] = useState(fromQtrValue);
  const [toQtr, setToQtr] = useState(toQtrValue);
  const [selectedData, setSelectedData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);
 
  React.useEffect(() => {
    if(searchType){
    dispatch(dispatchSelectType(searchType));
    }
  }, [searchType]);
  const convertTo4DigitQtr = (value) => {
    const tempValue = value.split('Q');

    tempValue.splice(1, 1, convertToFourDigitYear(tempValue[1]));
    return tempValue.join('Q');
  };
  // function to validate from Date and toDate on onblur
  const handleOnBlur = (type, input) => {
    const value = input;
    let allErrors = [];
    let fromError = [];
    let toError = [];
    if (type === 'fromQtr') {
      if (!value)
        fromError = [{ field: 'fromQtr', message: FROM_QTR_REQUIRED }];
      else if (value) fromError = validateQuarter(value, 'fromQtr');
      if (fromError.length === 0 && value.length == 4) {
        setFromQtr(convertTo4DigitQtr(value));
      } else {
        setFromQtr(value.toUpperCase());
      }
      if (!toQtr && !fromError.length) {
        setToQtr(autoFormateDate(fromQtr));
      }
    }
    if (type === 'toQtr') {
      if (!value) toError = [{ field: 'toQtr', message: TO_QTR_REQUIRED }];
      if (value) toError = validateQuarter(value, 'toQtr');
      if (toError.length === 0 && value.length == 4) {
        setToQtr(convertTo4DigitQtr(value));
      } else {
        setToQtr(value.toUpperCase());
      }
    }
    let frmDt, toDt;
    if (type === 'fromQtr' && value) frmDt = value;
    else frmDt = fromQtr;
    if (type === 'toQtr' && value) toDt = value;
    else toDt = toQtr;
    if (toDt && frmDt && fromError.length === 0 && toError.length === 0) {
      const toQtrYear =
        toQtr.length === 4
          ? convertTo4DigitQtr(toQtr).split('Q')
          : toQtr.split('Q');
      const fromQtrYear =
        fromQtr.length === 4
          ? convertTo4DigitQtr(fromQtr).split('Q')
          : fromQtr.split('Q');
      if (
        compareQuarterAndYear(
          toQtrYear[0],
          toQtrYear[1],
          fromQtrYear[0],
          fromQtrYear[1]
        ) === -1
      ) {
        allErrors.push({
          field: 'fromQtr>toQtr',
          message: FROM_QTR_CANNOT_BE_GREATER_THAN_TO_QTR,
        });
      }
    }
    allErrors = [...allErrors, ...fromError, ...toError];
    setErrorList(allErrors);
  };

  // variable deceleration for search type component
  const searchCompObj = requestCurrentDisData?.state?.searchTypeState;
  const [labelerFullScreen, setLabelerFullScreen] = React.useState(
    searchCompObj?.labelerFullScreenRedux
      ? searchCompObj?.labelerFullScreenRedux
      : false
  );
  const [ndcLeftFullScreen, setNdcLeftFullScreen] = React.useState(
    searchCompObj?.ndcLeftFullScreenRedux
      ? searchCompObj?.ndcLeftFullScreenRedux
      : false
  );
  const [ndcRightFullScreen, setNdcRightFullScreen] = React.useState(
    searchCompObj ? searchCompObj.ndcRightFullScreenRedux : false
  );
  const [labelerSelectedRow, setlabelerSelectedRow] = React.useState(
    labelerSelectedRowValue
  );

  const [ndcLeftSelectedRows, setNdcLeftSelectedRows] = React.useState(
    searchCompObj?.ndcLeftSelectedRowsRedux
      ? searchCompObj?.ndcLeftSelectedRowsRedux
      : []
  );
  const [ndcRightSelectedRows, setNdcRightSelectedRows] = React.useState(
    searchCompObj?.ndcRightSelectedRowsRedux
      ? searchCompObj?.ndcRightSelectedRowsRedux
      : []
  );
  const [labelerTableData, setlabelerTableData] = useState(
    searchCompObj?.labelerTableDataRedux
      ? searchCompObj?.labelerTableDataRedux
      : []
  );
  const [ndcLeftTableData, setNdcLeftTableData] =
    React.useState(ndcLeftTableDataArr);
  const [ndcRightTableData, setNdcRightTableData] = React.useState(selectedNDC);
  const [ndcSearchVal, setNdcSearchVal] = React.useState(
    searchCompObj?.ndcSearchTextRedux ? searchCompObj?.ndcSearchTextRedux : ''
  );
  const [ndcNameSearchVal, setNdcNameSearchVal] = React.useState(
    searchCompObj?.ndcNameSearchTextRedux
      ? searchCompObj?.ndcNameSearchTextRedux
      : ''
  );

  const errorMessagesOfSearchTypeComp =
    getErrorMsg?.searchScreenErrors?.length > 0
      ? _.filter(
          getErrorMsg?.searchScreenErrors,
          (l) => l?.errorComponent === 'searchTypeComponent' && l.message
        ).map((val) => val)
      : [];
  const [errorMsgFromSearchType, setErrorMsgFromSearchType] = React.useState(
    errorMessagesOfSearchTypeComp
  );

  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
          shortDesc: obj.shortDescription,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      const tempPlanType = planList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      setPlanType(plan || tempPlanType?.value);
    }
  }, [planTypeList]);

  React.useEffect(() => {
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
  }, []);

  React.useEffect(() => {
    if (planType) {
      rebatepgmDropdown(planType);
    }
  }, [planType]);

  const rebatepgmDropdown = async (planType) => {
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));

    // if (list.length) {
    setSelectList(list);

    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );

    setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
    // }
  };

  // If any error in errorlist it highlights the tab
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther('/ndchistoryreport', true);
    } else {
      tabHighLigther('/ndchistoryreport', false);
    }
  }, [JSON.stringify(getErrorMsg)]);

  // Function to get the labeler code data in case of NDC and name selected
  const getLabelerData = async () => {
    const labelerTableData = await getLabelerList({
      searchType: 'labeler',
    });
    setlabelerTableData(labelerTableData);
  };

  React.useEffect(() => {
    if (searchType !== 'Labeler') {
      getLabelerData();
    }
  }, []);

  // Handles the validation and if all is fine navigate to isplay screend
  const handleSearchClick = async (data, bypass) => {
    const errors = [];
    if (rebateProgram === '-1') {
      errors.push({
        field: 'rebateProgram',
        message: REBATE_SELECT,
      });
    }
    let fromError = [];
    let toError = [];
    if (!isAllQuarters) {
      fromError = validateQuarter(fromQtr, 'fromQtr');
      if (toQtr.trim().length > 0) {
        toError = validateQuarter(toQtr, 'toQtr');
      }

      if (
        toQtr.length &&
        fromQtr.length &&
        fromError.length === 0 &&
        toError.length === 0
      ) {
        const toQtrYear =
          toQtr.trim().length > 0 ? toQtr.split('Q') : fromQtr.split('Q');
        const fromQtrYear = fromQtr.split('Q');
        if (
          compareQuarterAndYear(
            toQtrYear[0],
            toQtrYear[1],
            fromQtrYear[0],
            fromQtrYear[1]
          ) === -1
        ) {
          errors.push({
            field: 'fromQtr>toQtr',
            message: FROM_QTR_CANNOT_BE_GREATER_THAN_TO_QTR,
          });
        }
      }
    }
    const allError = [...errors, ...fromError, ...toError];
    setErrorList(allError);
    // Sets store value using this action dispatch
    // data.sort((a, b) => a.drugSeqNum - b.drugSeqNum);
    // Variable to get fullname of rebate program from rebate program list(selectList)
    let rebateProgrameName =
      selectList.find((item) => item.rebateProgramCd === rebateProgram) || {};
    rebateProgrameName = `${rebateProgrameName?.rebateProgramCd} - ${
      rebateProgrameName?.shortDescr || ''
    }`;
    dispatch(
      setSearchInput({
        selectedPlanType: radioList.find((item) => item.value === planType)
          ?.shortDesc,
        rebateProgram,
        rebateProgrameName,
        plan: planType,
        errors: allError,
        selectedSearchType: searchType,
        labelerTableData,
        fromQtrValue: fromQtr,
        toQtrValue: toQtr,
        isAllQuartersValue: isAllQuarters,
        selectedNDC: data, // bypass ? data.filter((o, i) => i < 1000) : data,
        ndcLeftTableData,
        labelerSelectedRow,
        displayObj: {
          selectedNDC: data, //bypass ? data.filter((o, i) => i < 1000) : data,
          rebateProgram,
          rebateProgrameName,
          labelerTableData,
          rebateProgramList: rebateProgramListData,
          fromQtrValue: fromQtr,
          toQtrValue: toQtr,
          isAllQuartersValue: isAllQuarters,
        },
      })
    );

    /*
        if all the  error is cleaered then it will go to if block and
        set store value and navigate to Displayy Screen
    * */
    if (allError.length > 0 || data.length === 0) {
      if (allError.length > 0) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
      return;
    }
    if (allError.length === 0) {
      setSelectedData(data);
      if (!bypass) {
        if (data.length > 1000) {
          setOpenModal(true);
          return;
        }
      }
      setSelectedData([]);
      // if (data.length === 1) {
      //   setIsSearchClicked(true);
      //   dispatch(setNDCHistoryData([]));
      //   if (!toQtr) {
      //     setToQtr(fromQtr);
      //   }
      //   dispatch(
      //     getndchistorygrid({
      //       drugSeqNum: [data[0]?.drugSeqNum],
      //       rebateProgramCd: rebateProgram,
      //       startQtr: isAllQuarters ? '1Q1991' : fromQtr,
      //       toQtr: isAllQuarters
      //         ? `${moment(new Date()).quarter()}Q${new Date().getFullYear()}`
      //         : !toQtr && fromQtr
      //         ? fromQtr
      //         : toQtr ||
      //           `${moment(new Date()).quarter()}Q${new Date().getFullYear()}`,
      //     })
      //   );
      // } else {
      // sets the name for the dispaly screen
      let res = await dispatch(
        getndchistorygrid({
          drugSeqNum: data
            ?.filter((o, ind) => ind < 1000)
            .map((obj) => obj.drugSeqNum),
          rebateProgramCd: rebateProgram,
          startQtr: isAllQuarters ? '1Q1991' : fromQtr,
          toQtr: isAllQuarters
            ? `${moment(new Date()).quarter()}Q${new Date().getFullYear()}`
            : !toQtr && fromQtr
            ? fromQtr
            : toQtr ||
              `${moment(new Date()).quarter()}Q${new Date().getFullYear()}`,
        })
      );
      if (res?.length) {
        const grpData = Object.groupBy(res, ({ drugSeqNum }) => drugSeqNum);
        const availCodes = Object.keys(grpData);
        const filtered = data
          .filter(
            (obj) => availCodes.indexOf(obj?.drugSeqNum?.toString()) !== -1
          )
          .sort((o, i) => (o.ndc > i.ndc ? 1 : -1));
        dispatch(ndcHistoryDetailDisp(filtered));
        const updateTabs =
          JSON.parse(localStorage.getItem('tabItemsData')) === null
            ? []
            : JSON.parse(localStorage.getItem('tabItemsData'));
        updateTabs.push({
          navTo: '/ndchistorydisplay',

          value: 'Display NDC History',
        });
        localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
        props.history.push({
          pathname: '/ndchistorydisplay',
        });

        dispatch(clearReduxForFilterAndSort('/ndchistorydisplay'));
      }
    }
  };
  useEffect(() => {
    setErrorList(errors);
  }, [errors]);
    
  //remove no data error msg 
  React.useEffect(() => {
    dispatch(setSearchInput({ errors: [] }));
  }, [labelerFullScreen, !ndcLeftFullScreen, ndcRightFullScreen, planType, rebateProgram, isAllQuarters, fromQtr, toQtr, openModal]);

  if (isSearchClicked && searchResult.length > 0) {
    setIsSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/ndchistorydisplay',

      value: 'Display NDC History',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    props.history.push({
      pathname: '/ndchistorydisplay',
    });
    dispatch(clearReduxForFilterAndSort('/ndchistorydisplay'));
  }
  // hanlde onclick on of yes from confirmation modal
  const handleYes = () => {
    handleSearchClick(selectedData, true);
  };
  const errorMessages = [...new Set(errorList?.map((obj) => obj.message))];
   let firstInfo = '';
    firstInfo = `${rebateProgram}`;
  return (
    <div className="tabs-container">
      <CustomSeparator parent1="Detail Reports" parent2="NDC History" />
      <Spinner load={spinnerLoader} />
      <CommonModal
        open={openModal}
        viewAction
        viewHeader
        className="dialog-420"
        onOk={() => {
          setOpenModal(false);
          handleYes();
        }}
        okTitle="Ok"
        onClose={() => {
          setOpenModal(false);
          setSelectedData([]);
        }}
        closeTitle="Cancel"
        modalTitle="Confirmation Dialog"
        childrenComponent={<div className="p-3">{NDC_LIMIT_TO_1000}</div>}
      />
      <DisplayErrorMessages errorMessages={errorMessages} />
      <div className="tab-body custom-search-dates">
        {!labelerFullScreen && !ndcLeftFullScreen && !ndcRightFullScreen && (
          <>
            <div className="row mb-3">
              <div className="col-4 frr-two-col-radio">
                <RadioGroupComponent
                  data-testid="unallocated-balance-plan-by-radio-btn-plan"
                  id="filter-plan-by-radio-btn-action"
                  labelName="Plan Type"
                  required
                  optionList={radioList || []}
                  defaultValue={planType}
                  filterAction={(value) => {
                    setPlanType(value);
                    setRebateProgram('-1');
                    const errors = errorList.filter(
                      (error) => error.field !== 'noData'
                    );
                    setErrorList([...errors]);
                  }}
                  className="log-batch-filter-radio frr-checkInvoiceRadio"
                />
              </div>
              <div className="col-4">
                <Fieldset label="Rebate Program" required>
                  <div style={{ marginTop: 10 }}>
                    <SelectBoxComponent
                      data-testid="unallocated-balance-plan-by-radio-btn-Rbt"
                      id="filter-plan-by-radio-btn-action"
                      labelName="Rebate Program"
                      required
                      select
                      selectedOne
                      optionList={selectList || []}
                      defaultValue={rebateProgram}
                      filterAction={(value) => {
                        setRebateProgram(value);
                        const errors = errorList.filter(
                          (error) => error.field !== 'rebateProgram'
                        );
                        setErrorList([...errors]);
                      }}
                      isError={
                        errorList.find(
                          (error) => error.field === 'rebateProgram'
                        )?.message
                      }
                    />
                  </div>
                </Fieldset>
              </div>
              <div className="col-4">
                <Fieldset label="All Quarters">
                  <div
                    className="filter-checkbox"
                    style={{ marginTop: 10, height: 62 }}
                  >
                    <FormControlLabel
                      control={
                        <>
                          <div
                            style={{
                              width: 175,
                              marginLeft: 5,
                            }}
                          >
                            All Quarters:
                          </div>
                          <Checkbox
                            color="primary"
                            onChange={(e) => {
                              setIsAllQuarters(!isAllQuarters);
                              setFromQtr('');
                              setToQtr('');
                              setErrorList([
                                ...errorList.filter(
                                  (error) =>
                                    error.field !== 'fromQtr' &&
                                    error.field !== 'toQtr' &&
                                    error.field !== 'fromQtr>toQtr'
                                ),
                              ]);
                            }}
                            checked={isAllQuarters}
                          />
                        </>
                      }
                    />
                  </div>
                </Fieldset>
              </div>
            </div>

            <div className="row">
              <div className="col-6 mb-3">
                <Fieldset label="Quarter Range">
                  <div className="form-wrapper p-0 mt-n3">
                    <div className="mui-custom-form input-md field-xl">
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={6}>
                          <TextField
                            label="From"
                            id="From"
                            placeholder=""
                            data-testid="req-NDC-payment-quarter"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{ maxLength: 6 }}
                            required
                            name="From"
                            disabled={isAllQuarters}
                            value={fromQtr}
                            error={
                              errorList.filter(
                                (error) =>
                                  error.field === 'fromQtr' ||
                                  error.field === 'fromQtr>toQtr'
                              )?.length > 0
                                ? 'mandate-fields'
                                : ''
                            }
                            className="mandate-fields"
                            onBlur={(e) =>
                              handleOnBlur('fromQtr', e.target.value)
                            }
                            onChange={(e) => {
                              const { value } = e.target;

                              setFromQtr(value.toUpperCase());
                              setErrorList([
                                ...errorList.filter(
                                  (error) =>
                                    error.field !== 'fromQtr' &&
                                    error.field !== 'fromQtr>toQtr'
                                ),
                              ]);
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            label="To"
                            id="To"
                            placeholder=""
                            data-testid="req-NDC-payment-quarter-To"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            disabled={isAllQuarters}
                            required={false}
                            inputProps={{ maxLength: 10 }}
                            name="to"
                            value={toQtr}
                            onBlur={(e) =>
                              handleOnBlur('toQtr', e.target.value)
                            }
                            onChange={(e) => {
                              setToQtr(e.target.value.toUpperCase());
                              setErrorList([
                                ...errorList.filter(
                                  (error) =>
                                    error.field !== 'toQtr' &&
                                    error.field !== 'fromQtr>toQtr'
                                ),
                              ]);
                            }}
                            error={
                              errorList.filter(
                                (error) =>
                                  error.field === 'toQtr' ||
                                  error.field === 'fromQtr>toQtr'
                              )?.length > 0
                                ? 'mandate-fields'
                                : ''
                            }
                            className="mandate-fields"
                          />
                        </Grid>
                        <Grid xs={12} md={12}>
                          <p
                            className="MuiFormHelperText-root Mui-error Mui-required"
                            style={{
                              padding: '0px 10px',
                              fontSize: 12,
                              fontWeight: 600,
                            }}
                          >
                            {
                              errorList.find(
                                (error) =>
                                  error.field === 'fromQtr' ||
                                  error.field === 'toQtr' ||
                                  error.field === 'fromQtr>toQtr'
                              )?.message
                            }
                          </p>
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                </Fieldset>
              </div>
            </div>
          </>
        )}
        <div className="row">
          <div className="col-12">
            <SearchTypeComponent
              id="NDC History Report"             
              data-testid="search-type-ci"
              viewDetailButtonName={viewClaimDetailButton}
              searchType={searchType}
              setSearchType={setSearchType}
              firstInfo={firstInfo}
              getErrorsFromSearchTypeComponent={
                getErrorsFromSearchTypeComponent
              }
              errorMsgFromSearchType={errorMsgFromSearchType}
              setLabelerFullScreen={setLabelerFullScreen}
              labelerFullScreen={labelerFullScreen}
              setNdcLeftFullScreen={setNdcLeftFullScreen}
              ndcLeftFullScreen={ndcLeftFullScreen}
              setNdcRightFullScreen={setNdcRightFullScreen}
              ndcRightFullScreen={ndcRightFullScreen}
              handleViewDetailFunction={handleSearchClick}
              setlabelerSelectedRow={setlabelerSelectedRow}
              labelerSelectedRow={labelerSelectedRow}
              setNdcLeftSelectedRows={setNdcLeftSelectedRows}
              ndcLeftSelectedRows={ndcLeftSelectedRows}
              setNdcRightSelectedRows={setNdcRightSelectedRows}
              ndcRightSelectedRows={ndcRightSelectedRows}
              setlabelerTableData={setlabelerTableData}
              labelerTableData={labelerTableData}
              setNdcLeftTableData={setNdcLeftTableData}
              ndcLeftTableData={ndcLeftTableData}
              setNdcRightTableData={setNdcRightTableData}
              ndcRightTableData={ndcRightTableData}
              setNdcSearchVal={setNdcSearchVal}
              ndcSearchVal={ndcSearchVal}
              setNdcNameSearchVal={setNdcNameSearchVal}
              ndcNameSearchVal={ndcNameSearchVal}
              iconName="search"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
